import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQuery";

export const templateApi = createApi({
  reducerPath: "templateApi",
  baseQuery: baseQueryWithReauth, 
  endpoints: (builder) => ({
    getTemplates: builder.query({
      query: (params) => ({
        url: "template/",
        params,
      }),
    }),
    getTemplateById: builder.query({
      query: (templateId) => ({
        url: `template/${templateId}`,
      }),
    }),
    createTemplate: builder.mutation({
      query: (newTemplate) => ({
        url: "template",
        method: "POST",
        body: newTemplate,
      }),
    }),
    updateTemplate: builder.mutation({
      query: ({ id, updatedTemplate }) => ({
        url: `template/${id}`,
        method: "PUT",
        body: updatedTemplate,
      }),
    }),
    deleteTemplate: builder.mutation({
      query: (id) => ({
        url: `template/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetTemplatesQuery,
  useGetTemplateByIdQuery,
  useCreateTemplateMutation,
  useUpdateTemplateMutation,
  useDeleteTemplateMutation,
} = templateApi;